module.exports = __webpack_public_path__ + "img/instagramestory1.3522cf5b.jpg";